/**
 * Static helper class for extracting layout properties
 */
export class PluginHelper {
    /**
     * Determine if the cell is an attribute plugin
     * @param cell
     */
    static isConfigurationComponentPluginId(pluginId) {
        // Attribute:edit, ...
        const isAttribute = /ConfigurationComponent:/.test(pluginId);
        return isAttribute;
    }
    /**
     * Determine if the cell is an attribute sub component plugin
     * @param cell
     */
    static isConfigurationComponentPlugin(cell) {
        const pluginId = PluginHelper.getPluginId(cell);
        return PluginHelper.isConfigurationComponentPluginId(pluginId);
    }
    /**
     * Determine if the cell is an attribute plugin
     * @param cell
     */
    static isAttributePlugin(cell) {
        const pluginId = PluginHelper.getPluginId(cell);
        return PluginHelper.isAttributePluginId(pluginId);
    }
    /**
     * Determine if the cell is an attribute plugin
     * @param cell
     */
    static isAttributePluginId(pluginId) {
        // Attribute:edit, ...
        return /Attribute:/.test(pluginId);
    }
    /**
     * Determine if the cell is an attribute sub component plugin
     * @param cell
     */
    static isAttributeComponentPlugin(cell) {
        const pluginId = PluginHelper.getPluginId(cell);
        return PluginHelper.isAttributeComponentPluginId(pluginId);
    }
    /**
     * Determine if the cell is an attribute sub component plugin
     * @param cell
     */
    static isAttributeComponentPluginId(pluginId) {
        // Attribute:edit, ...
        const isAttribute = /AttributeComponent:/.test(pluginId);
        return isAttribute;
    }
    /**
     * Determine if the cell is an attribute control plugin
     * @param cell
     */
    static isControlPlugin(cell) {
        const pluginId = PluginHelper.getPluginId(cell);
        return PluginHelper.isControlPluginId(pluginId);
    }
    /**
     * Determine if the cell is an attribute control plugin
     * @param cell
     */
    static isControlPluginId(pluginId) {
        // Attribute:edit, ...
        const isAttribute = /Control:/.test(pluginId);
        return isAttribute;
    }
    /**
     * Determine if the cell is an attribute plugin
     * @param cell
     */
    static isValuePlugin(cell) {
        const pluginId = PluginHelper.getPluginId(cell);
        return PluginHelper.isValuePluginId(pluginId);
    }
    /**
     * Determine if the cell is an value plugin
     * @param cell
     */
    static isValuePluginId(pluginId) {
        // Attribute:edit, ...
        const isValue = /ValueContent:/.test(pluginId);
        return isValue;
    }
    /**
     * Get the plugin id
     * @param cell
     * @returns
     */
    static getPluginId(cell) {
        if (!cell.plugin) {
            return "";
        }
        return cell.plugin.id;
    }
    static getPluginClassName(cell) {
        return this.getPluginId(cell).replace(/[^A-z]/g, "-");
    }
    /**
     * Get the plugin props
     * @param cell
     * @returns
     */
    static getPluginProps(cell) {
        var _a, _b;
        if (!cell.dataI18n) {
            console.warn("Cell has no dataI18n", cell);
            return {};
        }
        const pluginProps = (_b = (_a = cell.dataI18n) === null || _a === void 0 ? void 0 : _a.default) !== null && _b !== void 0 ? _b : {};
        return pluginProps;
    }
    /**
     * Get the plugin props
     * @param cell
     * @returns
     */
    static getGridItemSxProps(cell) {
        const pluginId = PluginHelper.getPluginId(cell);
        // legacy: get sx props from plugin
        if (pluginId.endsWith(":GridItem")) {
            return PluginHelper.getPluginProps(cell);
        }
        // get sx props from cell preferences directly
        return cell.gridItemSx;
    }
}
//# sourceMappingURL=PluginHelper.js.map